import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'invitations';

const InvitationsModelGenerator = createRestAPIModelGenerator(TYPE);
export default InvitationsModelGenerator.createEntityModel();
